module.exports = __webpack_public_path__ + "94b394d1.png";